import React, { Component } from 'react'
import { Alert } from 'hljd'
import Style from '../style.module.less'

export default class extends Component {
  render() {
    return (
      <div className={Style.header}>
        <Alert
          message={
            <div>
              未推广的直播可在本页面直播预览页面查看直播情况，或者点击
              <span>“移动端直播预览”</span>
              查看用户端直播效果。
            </div>
          }
          type="warning"
          showIcon
        />
      </div>
    )
  }
}
